import { Component } from '@angular/core';
import { TrackingEventsComponent } from '@spartacus/order/components';

@Component({
  selector: 'app-custom-tracking-events',
  templateUrl: './custom-tracking-events.component.html',
  standalone: false
})
export class CustomTrackingEventsComponent extends TrackingEventsComponent {
}
